import dayjs from 'dayjs';
import Cookies from 'universal-cookie';

class ExamCookieService {
  static getAccessToken = () => {
    const cookie = new Cookies();
    return cookie.get('examAccessToken');
  };

  static getRefreshToken = () => {
    const cookie = new Cookies();
    return cookie.get('examRefreshToken');
  };

  static setAccessToken = (token: string) => {
    const cookie = new Cookies();
    return cookie.set('examAccessToken', token, {
      path: '/',
      expires: dayjs().add(30, 'day').toDate(),
    });
  };

  static setRefreshToken = (token: string) => {
    const cookie = new Cookies();
    return cookie.set('examRefreshToken', token, {
      path: '/',
      expires: dayjs().add(30, 'day').toDate(),
    });
  };

  static removeAll = () => {
    const cookie = new Cookies();
    cookie.remove('examAccessToken', {
      path: '/',
    });
    cookie.remove('examRefreshToken', {
      path: '/',
    });
  };
  //
  // private static getExpire = (date: number) => {
  //   return new Date(date);
  // };
}

export default ExamCookieService;
